<template>
	<div class="answer-box panel gray-small-square-1" :class="{ 'lg': large }">

		<div class="shadow left"></div>
		<div class="shadow top"></div>
		<div class="shadow right"></div>
		<div class="shadow bottom"></div>

		<div class="body">
			<div 
			v-if="pergunta != null" 
			class="pergunta" 
			:class="{ 'sem-enunciado':!comEnunciado }">

				<div v-if="comEnunciado" class="enunciado">
					<span>{{ currentNumber }}</span> {{ pergunta.Enunciado }}
				</div>
				<div v-if="!comEnunciado" class="enunciado">
					<span>{{ currentNumber }}</span>
				</div>

				<div class="opcoes">
					<div v-for="(opcao, index) in opcoes" class="opcao" :class="{ 'correta': opcao.Correta }">
						<radio 
						:disabled="locked"
						:key="opcao.Id"
						@checked="respondeu" 
						:checked="pergunta.RespostaId == opcao.Id" 
						:name="pergunta.Id" 
						:value="opcao.Id" 
						:text="opcao.Texto"></radio>
					</div>
				</div>
			</div>
			<div class="buttons">
				<div class="center">
					<strong>{{ this.currentNumber }}</strong> / {{ part.Perguntas.length }}
				</div>
				<button @click="previous" class="btn btn-gray previous left">Previous</button>
				<next :locked="locked" :click="next" :is-last-page="!hasNext()" :part="part"></next>
			</div>
		</div>
	</div>
</template>

<script>
	import bus from '@/bus/event-bus.js'
	import next from '../ui/NextButton'
	
	export default {
		props: ['part', 'comEnunciado', 'large', 'locked'],

		data() {
			return {
				partId: null,
				pergunta: null,
				currentNumber: 1
			}
		},

		watch: {
			part() {
				if(this.part.PartId !== this.partId) {
					this.setByNumber(1)
				}
			}
		},


		computed: {
			opcoes() {
				return this.pergunta.Opcoes
			}
		},

		mounted() {
			this.setByNumber(this.currentNumber)
		},

		methods: {

			respondeu(opcaoId) {
				var opcao = this.pergunta.Opcoes.find((e) => {
					return e.Id == opcaoId
				})

				this.pergunta.RespostaId = opcao.opcaoId
				this.pergunta.Respondeu = true
				bus.$emit('respondeu', opcaoId, this.pergunta.Id)
				this.$emit('respondeu', opcao, this.currentNumber)
			},

			setByNumber(i) {
				this.pergunta = this.part.Perguntas[i-1]
				this.partId = this.part.PartId
				this.currentNumber = i
			},

			next() {
				if(this.hasNext()) {
					var next = this.currentNumber + 1
					this.setByNumber(next)
					this.$emit('page-changed', next)
				} else {
					bus.$emit('next.part');
				}
			},

			previous() {
				if(this.hasPrevious()) {
					var prev = this.currentNumber - 1
					this.setByNumber(prev)
					this.$emit('page-changed', prev)
				} else {
					bus.$emit('previous.part');
				}			
			},

			hasNext() {
				return this.currentNumber < this.part.Perguntas.length
			},

			hasPrevious() {
				return this.currentNumber > 1;
			}

			
		},
		components: {
			'next': next
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/AnswerBox.vue